import React, { useEffect } from 'react';
import shortid from 'shortid';
import { Link } from 'gatsby';
import { TimelineLite, Power2 } from 'gsap';

import AuthLinks from 'components/authLinks';
import SocialMediaLinks from 'components/socialMediaLinks';
import { Title } from 'components/typography';
import { NAV_LINKS } from 'context/app/constants';

import { AFEX_SOLUTIONS } from './SideMenu.constants.js';
import {
  sideMenu,
  closeButton,
  solutionsLinks,
  navLinks,
  authLinks,
  ghostButton,
  sectionContainer,
  sideMenuContainer,
} from './scss/SideMenu.module.scss';

const SideMenu = () => {
  const timeline = new TimelineLite({ paused: true });
  useEffect(() => {
    timeline
      .fromTo(
        '#sideMenuContainer',
        0.6,
        {
          height: '0%',
          width: '100%',
          ease: Power2.easeOut,
        },
        {
          height: '100%',
          width: '100%',
          ease: Power2.easeInOut,
        },
        '-=0.2'
      )
      .fromTo(
        '#sideMenuHeader',
        0.5,
        { opacity: 0, y: -40 },
        { opacity: 1, y: 0 }
      )
      .fromTo(
        '#sideMenuFooter',
        0.5,
        { opacity: 0, y: 40 },
        { opacity: 1, y: 0 },
        '-=0.5'
      )
      .staggerFromTo(
        '.afexSolutionLink',
        0.5,
        { opacity: 0, x: 40 },
        { opacity: 1, x: 0 },
        0.05,
        '-=0.5'
      )
      .staggerFromTo(
        '#sideMenuLinks li',
        0.5,
        { y: 60, opacity: 0 },
        { y: 0, opacity: 1 },
        0.03,
        '-=0.5'
      )
      .delay(0.4);
  });

  const openSideMenu = () => {
    timeline.play().timeScale(1);
  };

  const closeSideMenu = () => {
    timeline.reverse().timeScale(2);
  };

  return (
    <>
      <button
        className={ghostButton}
        onClick={openSideMenu}
        aria-label="click to open side menu"
      />
      <div id="sideMenuContainer" className={sideMenuContainer}>
        <div className={sideMenu}>
          <header id="sideMenuHeader">
            <button
              type="button"
              onClick={closeSideMenu}
              className={closeButton}
            >
              <Title value="X CLOSE" size="sm" />
            </button>
            <AuthLinks theme="white" className={authLinks} />
          </header>

          <section className={sectionContainer}>
            <div id="sectionRow">
              <div className={solutionsLinks}>
                {AFEX_SOLUTIONS.map(({ label, href }) => (
                  <div key={shortid()} className="afexSolutionLink">
                    <Link to={href}>
                      <Title value={label} size="xl" fontStyle="regular" />
                    </Link>
                  </div>
                ))}
              </div>
            </div>

            <nav className={navLinks}>
              <ul id="sideMenuLinks">
                {NAV_LINKS.map(({ label, href }) => (
                  <li key={shortid()}>
                    <Link to={href}>{label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          </section>
          <footer id="sideMenuFooter">
            <SocialMediaLinks iconType="circular" />
          </footer>
        </div>
      </div>
    </>
  );
};

export default SideMenu;
